import { render } from "./PositionDetailsTable.vue?vue&type=template&id=6985cd26&scoped=true&ts=true"
import script from "./PositionDetailsTable.vue?vue&type=script&lang=ts"
export * from "./PositionDetailsTable.vue?vue&type=script&lang=ts"

import "./PositionDetailsTable.vue?vue&type=style&index=0&id=6985cd26&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6985cd26"]])

export default __exports__